import React from "react";
import Search from "../components/search/Search";

const Main = () => {
  return (
    <div className="page">
      <Search />
    </div>
  );
};

export default Main;
